import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const TestimonialsSection = () => {
  return (
    <section className="section-padding bg-[#fffef2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="hero-subtitle text-[#666] mb-4">
            Testimonios
          </p>
          <h2 className="section-title text-[#333] mb-6">
            Lo que dicen mis clientas
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="testimonial-card p-8 card-hover"
            >
              {/* Quote Icon */}
              <Quote size={32} className="text-[#bcbbb4] mb-6" strokeWidth={1} />

              {/* Text */}
              <p className="body-regular text-[#666] mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    size={14}
                    className="text-[#333]"
                    fill="#333"
                  />
                ))}
              </div>

              {/* Author */}
              <div className="border-t border-[#bcbbb4]/50 pt-4">
                <p className="font-body text-sm font-medium text-[#333]">
                  {testimonial.name}
                </p>
                <p className="text-xs text-[#666] mt-1">
                  {testimonial.role}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
